module.exports = __webpack_public_path__ + "assets/afa1e49004951609e5b905f8aeaf4505.png";